/**
 * Converts a pose filename to its corresponding video path.
 * Based on the demo.js implementation.
 * @param poseFileName - Pose file name (e.g., "exercise_name.json")
 * @returns Path to the corresponding video file
 */
export function poseFilenameToVideoPath (poseFileName: string, forceGender?: 'male' | 'female'): string {
  const split = poseFileName.split('_')
  const exercise = split.shift()
  let filename = split.join('_').replace('.json', '.mp4')

  if (forceGender) {
    // necessary because "female" contains the word "male"
    filename = filename.replace('female-', 'male-')
    if (forceGender == 'female')
      filename = filename.replace('male-', 'female-')
  }

  // Check if we're in localhost for local development
  // if (window.location.hostname === 'localhost') {
  //   const localPath = `/media/${exercise}/${filename}`

  //   return localPath
  // }

  // Production URL
  const MEDIA_URL = 'https://gymmy-media.s3.eu-north-1.amazonaws.com/media'
  const productionPath = `${MEDIA_URL}/${exercise}/${filename}`

  return productionPath
}
